import api from './api'
import type { UserApiToken, UserApiTokenCreated } from '@/types'
import type { ApiResponse, CreateApiTokenRequest } from '@/types/api'

const ApiTokensService = {
  async list(): Promise<UserApiToken[]> {
    const response = await api.get<ApiResponse<UserApiToken[]>>('/api/v1/auth/api-tokens')
    return response.data.data
  },

  async create(data: CreateApiTokenRequest): Promise<UserApiTokenCreated> {
    const response = await api.post<ApiResponse<UserApiTokenCreated>>(
      '/api/v1/auth/api-tokens',
      data,
    )
    return response.data.data
  },

  async revoke(tokenId: string): Promise<UserApiToken> {
    const response = await api.delete<ApiResponse<UserApiToken>>(
      `/api/v1/auth/api-tokens/${tokenId}`,
    )
    return response.data.data
  },
}

export default ApiTokensService
